<template>
    <div class="pay-content">
        <el-card class="box-card">
            <div class="table-box">
                <div class="card-title">资源名称:</div>
                <el-input v-model="headerData.resourceName" clearable class="handle-input" placeholder="请输入资源名称"></el-input>
            </div>
            <div class="table-box">
                <div class="card-title">型号:</div>
                <el-input v-model="headerData.model" clearable class="handle-input" placeholder="请输入型号"></el-input>
            </div>
            <div class="table-box">
                <div class="card-title">组网:</div>
                <el-input v-model="headerData.networking" clearable class="handle-input" placeholder="请输入组网"></el-input>
            </div>
            <div class="table-box">
                <div class="card-title">租用类型:</div>
                <el-select v-model="headerData.rentType" clearable placeholder="请选择租用类型">
                    <el-option label="月租" value="1"></el-option>
                    <el-option label="年租" value="2"></el-option>
                </el-select>
            </div>
            <div class="table-box">
                <div class="card-title">租用地点:</div>
                <el-select class="handle-input" v-model="headerData.resLocation" clearable placeholder="请选择地点">
                    <el-option
                        v-for="item in headerData.optionLocation"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <el-button type="primary" @click="getSearchList">查询</el-button>
        </el-card>
        <el-card class="box-card mt20">
            <el-table
                :data="tableData"
                border
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
            >
                <el-table-column prop="resourceName" label="资源名称"></el-table-column>
                <el-table-column prop="cpuCore" label="CPU核心数"></el-table-column>
                <el-table-column prop="memoryCapacity" label="内存容量"></el-table-column>
                <el-table-column prop="hardDisk" label="硬盘容量"></el-table-column>
                <el-table-column prop="model" label="型号"></el-table-column>
                <el-table-column prop="networking" label="组网"></el-table-column>
                <el-table-column prop="cardsNum" label="卡数"></el-table-column>
                <el-table-column prop="networking" label="资源可租">
                    <template slot-scope="{row}">
                        <span v-if="row.rentOn == 1" style="color:#FFB400">随时可租</span>
                        <span v-if="row.rentOn == 2" style="color:#4B0082">指定日期可租</span>
                    </template>
                </el-table-column>
                <el-table-column prop="networking" label="可租日期">
                    <template slot-scope="{row}">
                        <span v-if="row.rentOn == 2">{{ row.rentDate }}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="networking" label="资源价格">
                    <template slot-scope="{row}">
                        <span v-if="row.monthRent != null">{{ row.monthRent }}</span>
                        <span v-else>{{ row.yearRent }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="monthRent" label="审核状态">
                    <template slot-scope="{row}">
                        <span v-if="row.resourceState == 0" style="color:#F56C6C">审核拒绝</span>
                        <span v-if="row.resourceState == 1 || row.resourceState == 2" style="color:#67C23A">审核通过</span>
                        <span v-if="row.resourceState == 3" style="color:#0066ff">待审核</span>
                    </template>
                </el-table-column>
                <el-table-column prop="networking" label="资源状态">
                    <template slot-scope="{row}">
                        <!-- <span v-if="row.onSale == 1" >上架</span>
                        <span v-if="row.onSale == 2" >下架</span> -->
                        <!-- 待使用、使用中 -->
                        <span v-if="row.onSale == 1" style="color:#F56C6C">待使用</span>
                        <span v-if="row.onSale == 2" style="color:#67C23A">使用中</span>
                    </template>
                </el-table-column>
                <el-table-column prop="monthRent" label="资源上下架">
                    <template slot-scope="{row}">
                        <el-tag v-if="row.onSale == 2" @click="getSetUp(row.id)">资源上架</el-tag>
                        <el-tag type="warning" v-if="row.onSale == 1" @click="getSetDown(row.id)">资源下架</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="{row}">
                        <el-link type="primary" class="mr10" @click="getResourceDetail(row)">编辑</el-link>
                        <el-link type="danger" :disabled="row.resourceState != 3" @click="getResourceDel(row)">删除</el-link>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :current-page="query.currentPage"
                    :page-size="query.pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="query.total">
                </el-pagination>
            </div>
        </el-card>
        <el-dialog title="资源编辑" :visible.sync="isVisibleResourceDetail" width="800px" >
            <el-form  label-width="110px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="资源名称">
                            <el-input class="handle-input" v-model="resourceData.resourceName" clearable placeholder="请输入资源名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="CPU核心数">
                            <el-input class="handle-input" v-model="resourceData.cpuCore" clearable placeholder="请输入CPU核心数">
                                <template #append>
                                    核
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="内存容量">
                            <el-input class="handle-input" v-model="resourceData.memoryCapacity" clearable placeholder="请输入内存容量">
                                <template #append>
                                    GB
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="硬盘容量">
                            <el-input class="handle-input" v-model="resourceData.hardDisk" clearable placeholder="请输入硬盘容量">
                                <template #append>
                                    GB
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="型号">
                            <el-input class="handle-input" v-model="resourceData.model" clearable placeholder="请输入型号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="卡数">
                            <el-input class="handle-input" v-model="resourceData.cardsNum" clearable placeholder="请输入卡数"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="组网">
                            <el-input class="handle-input" v-model="resourceData.networking" clearable placeholder="请输入组网"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="台数">
                            <el-input class="handle-input" v-model="resourceData.rentableNum" clearable placeholder="请输入台数"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="可接受付款方式">
                            <el-input class="handle-input" v-model="resourceData.payType" clearable placeholder="请输入可接受的付款方式"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="地点">
                            <el-select class="handle-input" v-model="resourceData.address" clearable placeholder="请选择地点">
                                <el-option
                                v-for="item in headerData.optionLocation"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="资源状态">
                             <el-radio-group v-model="resourceData.rentOn">
                                <el-radio :label="1">随时可租</el-radio>
                                <el-radio :label="2">指定日期可租</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="resourceData.rentOn === 2">
                        <el-form-item label="可租日期">
                            <el-date-picker
                                class="handle-input"
                                v-model="resourceData.rentDate"
                                type="date"
                                placeholder="请选择可租日期"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="月租金额">
                            <el-input class="handle-input" v-model="resourceData.monthRent" clearable placeholder="请输入月租金额"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="年租金额">
                            <el-input class="handle-input" v-model="resourceData.yearRent" clearable placeholder="请输入年租金额"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                <el-form-item label="资源描述">
                    <el-input type="textarea" v-model="resourceData.resourceDesc" clearable placeholder="请输入资源描述"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="resourceData.remark" clearable placeholder="请输入备注内容"></el-input>
                </el-form-item>
            </el-form>
            
            <div slot="footer" class="dialog-footer">
                <el-button >取 消</el-button>
                <el-button type="primary" @click="getSaveData">保 存</el-button>
            </div>
        </el-dialog>
    </div>
    
</template>

<script>
import {
    resourceReleaseList,
    resourceReleaseDetail,
    resourceReleaseSave,
    resourceReleaseSetUP,
    resourceReleaseSetDown,
    resourceReleaseDel
} from '@/api/index'
export default {
    data() {
        return {
            headerData:{
                resourceName:"",//资源名称
                model:"",//型号
                networking:"",//组网
                rentType:"",//租用类型
                resLocation:"",//租用地点
                optionLocation:[
                    {
                        value: '北京',
                        label: '北京'
                    },{
                        value: '新疆',
                        label: '新疆'
                    },{
                        value: '青海',
                        label: '青海'
                    },{
                        value: '上海',
                        label: '上海'
                    },{
                        value: '广州',
                        label: '广州'
                    },{
                        value: '温州',
                        label: '温州'
                    },{
                        value: '郑州',
                        label: '郑州'
                    },{
                        value: '宁夏',
                        label: '宁夏'
                    },{
                        value: '廊坊',
                        label: '廊坊'
                    },{
                        value: '连云港',
                        label: '连云港'
                    },{
                        value: '金华',
                        label: '金华'
                    },{
                        value: '厦门',
                        label: '厦门'
                    },
                ],
            },
            tableData:[],
            query:{
                currentPage:1,
                pageSize:10,
                total:0,
            },
            isVisibleResourceDetail:false,
            resourceData:{},
            resourceId:"",
            
        };
    },

    mounted() {
        this.getResourceBuyList()
    },

    methods: {
        getSearchList(){
            this.query.currentPage = 1;
            this.getResourceBuyList()
        },
        async getResourceBuyList(){
            let data = {
                pageNum:this.query.currentPage,
                pageSize:this.query.pageSize,
                address:this.headerData.resLocation,
                model:this.headerData.model,
                networking:this.headerData.networking,
                resourceState:this.headerData.rentType, //1 月租  2 年租
                resourceName:this.headerData.resourceName
            }
            const resData = await resourceReleaseList(data)
            // console.log(resData)
            if(resData.success){
                this.tableData = resData.data.records
                this.query.total = resData.data.total
            }
        },
        handleCurrentChange(val) {
            this.query.currentPage = val;
            this.getResourceBuyList()
        },
        async getResourceDetail(row){
            const resData = await resourceReleaseDetail(row.id);
            
            this.resourceData = {};
            if(resData.success){
                this.resourceData = resData.data;
                this.isVisibleResourceDetail = true;
            }
            // 
            // let data = {
            //     pageNum:this.grid.currentPage, 
            //     pageSize:this.grid.pageSize,   
            //     orderId:this.resourceId,
            // }
            // const resData = await resourceView(data);
            // console.log(resData);
            // if(resData.success){
            //     this.gridData = resData.data.records;
            //     this.grid.total = resData.data.total;
            //     this.isVisibleResourcesView = true;
            // }
        },
        getSaveData(){
            let data = {
                rid:this.resourceData.id,
                resourceName:this.resourceData.resourceName,
                cpuCore:this.resourceData.cpuCore,
                memoryCapacity:this.resourceData.memoryCapacity,
                hardDisk:this.resourceData.hardDisk,
                model:this.resourceData.model,
                cardsNum:this.resourceData.cardsNum,
                networking:this.resourceData.networking,

                payType:this.resourceData.payType,
                address:this.resourceData.address,
                rentOn:this.resourceData.rentOn,
                rentDate:this.resourceData.rentDate,
                monthRent:this.resourceData.monthRent,
                yearRent:this.resourceData.yearRent,
                resourceDesc:this.resourceData.resourceDesc,
                remark:this.resourceData.remark,
                

            }
            // console.log(data);
            // return;
            resourceReleaseSave(data).then((res)=>{
                console.log(res);
                if(res.data){
                    this.$message.success('更新成功');
                    this.getResourceBuyList();
                    this.isVisibleResourceDetail = false;
                }
            })
        },
        async getSetUp(id){
            const data1 = await resourceReleaseSetUP(id);
            if(data1.data){
                this.$message.success('更新成功');
                this.getResourceBuyList();
            }
        },
        async getSetDown(id){
            const data2 = await resourceReleaseSetDown(id);
            if(data2.data){
                this.$message.success('更新成功');
                this.getResourceBuyList();
            }
        },
        getResourceDel(row){
            this.$confirm(`确认删除 ${row.resourceName}, 是否继续?`, '提示', {
                showClose:false,
                closeOnClickModal:false,
				closeOnPressEscape:false,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const resData = await resourceReleaseDel(row.id);
                if(resData.data){
                    this.$message.success('删除成功');
                    this.query.currentPage = 1;
                    this.getResourceBuyList();
                }else{
                    this.$message.error('删除失败');
                }
            }).catch(()=>{
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            })
        }
    },
};
</script>

<style scoped>
.pay-content{
    width:100%;
    height:auto;
    min-height:calc(100vh - 200px);
    box-sizing: border-box;
	padding:20px 20px;
	background-color: #f9fafb;
}
.table-box{
    display:inline-block;
    margin-right:10px;
}
.card-title{
    display:inline-block;
    margin-right:10px;
    font-size:14px;
    line-height:40px;
}
.handle-input{
    width:240px;
}

</style>